// pt-BR of the D36 shell and New project strings (en-shell.ts). Complete, checked by the type.
import type { enShell } from "./en-shell.ts";

export const ptBRShell: Record<keyof typeof enShell, string> = {
  "nav.expand": "Expandir navegação",
  "nav.collapse": "Recolher navegação",
  "nav.pin": "Manter navegação aberta",
  "nav.brand": "Primage Studio",

  "assistant.reopen": "Abrir assistente",

  "createProject.chooseDescription": "Comece de um repositório que você já tem no GitHub ou do zero.",
  "createProject.choiceLabel": "Como você quer começar?",
  "createProject.fromGithub": "Importar um repositório do GitHub",
  "createProject.fromGithubHint": "Escolha um repositório do seu GitHub conectado: o projeto recebe o nome e a branch padrão dele.",
  "createProject.fromGithubAdminOnly": "Só administradores da organização podem importar do GitHub.",
  "createProject.blank": "Projeto em branco",
  "createProject.blankHint": "Comece vazio — só o nome é obrigatório. Dá para conectar um repositório depois.",
  "createProject.blankDescription": "Só o nome é obrigatório; o resto já vem com valores padrão.",
  "createProject.noGithub": "Nenhuma integração do GitHub está conectada ainda.",
  "createProject.openIntegrations": "Conectar o GitHub em Integrações",
  "createProject.advanced": "Configurações avançadas",
  "createProject.advancedSummary": "Padrão: branch {branch} · {delivery} · {autonomy}",
  "createProject.nameExample": "Por exemplo: Sistema de estoque",

  "projects.scopeAll": "Todas as tarefas",
  "error.network": "Não foi possível falar com a API. Confira sua conexão e tente de novo.",
  "error.uploadInterrupted": "O envio foi interrompido. Seu conteúdo não se perdeu; tente de novo.",
};
